<!-- Start Hero -->
<section class="relative table w-full py-36 bg-[url('/assets/images/parallax/archer_1400x875.jpg')] bg-center bg-no-repeat bg-cover">
  <div class="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900"></div>
  <div class="container">
    <div class="grid grid-cols-1 pb-8 text-center mt-10">
      <h3 class="md:text-3xl text-2xl md:leading-snug tracking-wide leading-snug font-medium text-white">{{ "DOWNLOADS.CLIENT_TITLE" | translate }}</h3>
    </div><!--end grid-->
  </div><!--end container-->
</section><!--end section-->
<!-- End Hero -->

<!-- Start Section-->
<section class="relative md:py-24 py-16">
  <div class="container">
    <!-- Loading Indicator -->
    <div *ngIf="loading" class="flex justify-center items-center py-10">
      <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-violet-600"></div>
    </div>

    <!-- Error Message -->
    <div *ngIf="error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-6" role="alert">
      <span class="block sm:inline">{{ error }}</span>
    </div>

    <!-- Client Data -->
    <div *ngIf="clientData && !loading" class="bg-white dark:bg-slate-900 shadow-md dark:shadow-gray-800 rounded-md overflow-hidden">
      <div class="p-6">
        <h2 class="text-2xl font-bold mb-2">{{ clientData.name }}</h2>
        <p class="text-gray-600 dark:text-gray-400 mb-6">{{ clientData.description }}</p>

        <!-- Download Buttons -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div *ngFor="let provider of getProviders()" class="flex flex-col">
            <a [href]="clientData.files[provider]" target="_blank" rel="noopener noreferrer"
               class="btn bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white rounded-md">
              <span>{{ provider | translate }}</span>
            </a>
          </div>
        </div>

        <!-- Article Link if available -->
        <div *ngIf="clientData.articleId" class="mt-6">
          <a [routerLink]="['/read', clientData.articleId]"
             class="text-violet-600 hover:text-violet-700 font-medium">
            {{ clientData.articleTitle || 'Read more about this client' }}
          </a>
        </div>
      </div>
    </div>

    <!-- No Data Message -->
    <div *ngIf="!clientData && !loading && !error" class="text-center py-10">
      <p class="text-gray-600 dark:text-gray-400">No client download information available.</p>
    </div>
  </div>
</section>
